import ResultsPage from './ResultsPage';

export default ResultsPage;
